const AUDIT_LOG_EVENTS = {
  ORG_ADD_TEAM: 'org.add.team',
  ORG_DELETE_TEAM: 'org.delete.team',
  ORG_ADD_USER: 'org.add.user',
  ORG_REMOVE_USER: 'org.remove.user',
  TEAM_ADD_USER: 'team.add.user',
  TEAM_REMOVE_USER: 'team.remove.user',
  TEAM_ADD_PACKAGE: 'team.add.package',
  TEAM_REMOVE_PACKAGE: 'team.remove.package',
  TEAM_UPDATE_PACKAGE_ACCESS: 'team.update.packageaccess',
  PACKAGE_PUBLISH: 'package.publish',
  PACKAGE_UNPUBLISH: 'package.unpublish',
  PACKAGE_DEPRECATE: 'package.deprecate',
  PACKAGE_ADD_DIST_TAG: 'package.add.disttag',
  PACKAGE_REMOVE_DIST_TAG: 'package.remove.disttag',
  PACKAGE_UPDATE_ACCESS: 'package.update.access'
}

module.exports = AUDIT_LOG_EVENTS
